import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SMA.css';  // You can reuse or rename to your CSS file
import { BASE_URL } from '../../Config';
import Toast from '../../Toast';
import logoImage from '../../../resources/1000028180.jpeg';

export default function NervousFeeling() {
  const questions = [
    'I feel nervous before games.',
    'I worry about making mistakes.',
    'I get butterflies in my stomach.',
    'I feel tense during important moments.',
    'I am afraid of letting my team down.',
  ];

  const [responses, setResponses] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('warning');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('smaU10') || '{}');
    if (savedData.nervous_feelings && Array.isArray(savedData.nervous_feelings)) {
      const savedResponses = {};
      savedData.nervous_feelings.forEach((value, index) => {
        savedResponses[index] = Number(value);
      });
      setResponses(savedResponses);
    }
  }, []);

  const handleSelect = (index, value) => {
    const updated = { ...responses, [index]: value };
    setResponses(updated);

    // For the "Feeling Nervous" section, reverse the scoring
    // "Yes, a lot" should be 1, "Sometimes" should be 2, "No, not really" should be 3
    const nervous_feelingsArray = Object.keys(updated)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => {
        const originalValue = updated[key];
        // Reverse the scoring: 1->3, 2->2, 3->1
        return originalValue === 1 ? 3 : originalValue === 2 ? 2 : 1;
      });

    const existing = JSON.parse(localStorage.getItem('smaU10') || '{}');
    localStorage.setItem('smaU10', JSON.stringify({
      ...existing,
      nervous_feelings: nervous_feelingsArray,
    }));
  };

  const handleSubmit = async () => {
    if (questions.some((_, idx) => !responses[idx])) {
      setToastMessage('Please answer all questions before submitting.');
      setToastType('warning');
      setShowToast(true);
      return;
    }

    setIsSubmitting(true);
    const token = localStorage.getItem('token');
    if (!token) {
      setToastMessage('Please log in to submit your test.');
      setToastType('error');
      setShowToast(true);
      setIsSubmitting(false);
      navigate('/login');
      return;
    }

    try {
      // Gather all section responses from localStorage
      const allSections = JSON.parse(localStorage.getItem('smaU10') || '{}');
      const payload = {
        test_type: 'SMA-U10',
        responses: allSections
      };
      console.log('Submitting SMA-U10 payload:', payload);
      const response = await fetch(`${BASE_URL}/api/test/submit_test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      console.log(response);
      if (response.status === 401) {
        localStorage.removeItem('token');
        setToastMessage('Your session has expired. Please log in again.');
        setToastType('error');
        setShowToast(true);
        setIsSubmitting(false);
        navigate('/login');
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to submit test');
      }

      setToastMessage('Test submitted successfully!');
      setToastType('success');
      setShowToast(true);
      setTimeout(() => {
        handleReturnToDashboard();
        navigate('/test-summary');
      }, 1200);
    } catch (error) {
      setToastMessage('Failed to submit test. Please try again.');
      setToastType('error');
      setShowToast(true);
      setIsSubmitting(false);
    }
  };
  const handleReturnToDashboard = () => {
    localStorage.removeItem('smaU10');
    localStorage.removeItem('mtt20');
    localStorage.removeItem('pat10');
    localStorage.removeItem('smft30');
    navigate('/dashboard');
  };

  const currentSection = 4;
  const totalSections = 4;

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
      fontFamily: 'Poppins, sans-serif',
    }}>
      <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo">Power Mind Metrics</h1>
          </div>
          <nav className="header-nav">
            <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
        </div>
      </header>
      <div style={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 64,
      }}>
        <div
          style={
            window.innerWidth > 600
              ? {
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: 1028,
                  height: 930,
                  padding: 24,
                  opacity: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  marginBottom: 50,
                }
              : {
                  background: '#fff',
                  borderRadius: '1.2rem',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: '100vw',
                  maxWidth: '98vw',
                  minWidth: 0,
                  padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                  boxSizing: 'border-box',
                  margin: 0,
                  marginBottom: '80px',
                }
          }
        >
          <h1 style={{fontWeight: 700, fontSize: 32, color: '#444', marginBottom: 16, textAlign: 'center'}}>SMA U10 Assessment</h1>
          <div style={{width: '100%', marginBottom: 24}}>
            <div style={{fontWeight: 500, fontSize: 20, marginBottom: 8}}>Step 4 of 4: <span style={{fontWeight: 600}}>Feeling Nervous 😰</span></div>
            <div style={{display: 'flex', flexDirection: 'row', gap: 16, width: '100%', marginTop: 8, marginBottom: 8}}>
              {[1,2,3,4].map((step) => (
                <div
                  key={step}
                  style={{
                    flex: 1,
                    height: 10,
                    borderRadius: 6,
                    background: currentSection >= step ? '#2AA7A1' : '#e0e0e0',
                    transition: 'background 0.3s',
                  }}
                />
              ))}
            </div>
          </div>
          {questions.map((question, index) => (
            <div key={index} style={{marginBottom: 24, width: '100%'}}>
              <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8, textAlign: 'left'}}>{question}</div>
              {window.innerWidth > 600 ? (
                <>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4, width: '100%'}}>
                    {[1, 2, 3].map((value) => (
                      <span key={value} style={{fontSize: 13, color: '#444', width: 180, textAlign: 'center'}}>
                        {value === 1 ? 'No, not really' : value === 2 ? 'Sometimes' : 'Yes, a lot'}
                      </span>
                    ))}
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                    {[1,2,3].map((value) => (
                      <label key={value} style={{width: 180, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <input
                          type="radio"
                          name={`q${index}`}
                          value={value}
                          checked={responses[index] === value}
                          onChange={() => handleSelect(index, value)}
                          style={{width: 18, height: 18, accentColor: ' rgb(15, 148, 150)',}}
                        />
                      </label>
                    ))}
                  </div>
                </>
              ) : (
                (() => {
                  // Mobile: options in pairs of two, with radio before label, using mtt20 classes
                  const answerLabels = ['No, not really', 'Sometimes', 'Yes, a lot'];
                  const pairs = [[1,2],[3]];
                  return pairs.map((pair, rowIdx) => (
                    <div key={rowIdx} className="mtt20-options-pair-row">
                      {pair.map((value) => (
                        <label key={value} className="mtt20-option-label">
                          <input
                            type="radio"
                            name={`q${index}`}
                            value={value}
                            checked={responses[index] === value}
                            onChange={() => handleSelect(index, value)}
                            className="mtt20-radio"
                          />
                          <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
                        </label>
                      ))}
                    </div>
                  ));
                })()
              )}
            </div>
          ))}
          <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 24}}>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              style={{
                border: '2px solid #2aa7a1',
                background: '#fff',
                color: '#2aa7a1',
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 16,
                fontFamily: 'Poppins, sans-serif',
                cursor: 'pointer',
                transition: 'background 0.2s, color 0.2s',
                height: 40,
                width: 107,
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
              style={{
                border: 'none',
                background: isSubmitting ? '#9ca3af' : '#2aa7a1',
                color: '#fff',
                borderRadius: 8,
                fontWeight: 500,
                fontSize: 16,
                fontFamily: 'Poppins, sans-serif',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s',
                height: 40,
                width: 170,
              }}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Test'}
            </button>
          </div>
          {showToast && (
            <Toast
              message={toastMessage}
              type={toastType}
              onClose={() => setShowToast(false)}
            />
          )}
        </div>
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}
